import { API } from '.'
import qs from 'qs'

export default {
   subscribe: ({ email, recaptcha }) => {
      return API.post(`${process.env.NEWSLETTER_BASE_URL}emailAddresses/${email}/register`, qs.stringify({ recaptcha }))
   }
}


// WEBPACK FOOTER //
// ./src/api/newsletter.js